module.exports = __webpack_public_path__ + "static/after-839a3081836901be00e2001d622590d2.png";